<template>
  <div>
    <van-nav-bar
      class="backBox"
      title="使用记录"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="content_box">
      <div class="listBox">
        <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          success-text="刷新成功"
          :disabled="errorFlag"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text="没有更多了"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="onLoad"
          >
            <div
              v-for="item in recordListData"
              class="list-item"
              :key="item.id"
            >
              <div class="at-name">
                {{ item.building_no }} {{ item.building_floor }}
                {{ item.room_name }} {{ item.type_name }}
              </div>
              <div class="predict-up-parent">
                <div class="predict-up-text">预计签到时间：</div>
                <div class="predict-up-text">{{ item.set_useTime }}</div>
                <span
                  class="sign-inout-btn"
                  v-if="h5Config.funCfg.openBackSignIn && !item.back_begin_time"
                  @click="backIn(item)"
                  >返回签入</span
                >
                <!-- <span
                  class="sign-inout-btn"
                  v-if="item.back_begin_time && !item.back_in_time"
                  @click="backQr(item)"
                  >开锁二维码</span
                > -->
              </div>
              <div class="sj-up-parent">
                <div class="sj-up-text">实际签到时间：</div>
                <div class="sj-up-text">{{ item.set_sjUseTime }}</div>
                <div
                  class="sign-inout-btn"
                  v-if="h5Config.funCfg.openBackSignIn && item.back_in_time && !item.back_out_time"
                  @click="backOut(item)"
                >
                  返回签出
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
import { Dialog, Toast } from 'vant'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      pageOption: {
        total: 0,
        page_no: 1,
        page_size: 15
      },
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      errorFlag: false,
      recordListData: [

      ]
    }
  },
  mounted () {
    this.queryList()
  },
  computed: {
    ...mapGetters([
      'h5Config'
    ])
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    backIn (item) {
      Toast.loading({
        message: '请稍后...',
        forbidClick: true
      })
      const para = {
        use_id: item.id
      }
      api
        .axiosRequest(api.urlList.backSignIn, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            this.backQR(item)
          } else {
            Toast.fail('签入失败' + res.msg)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    // todo  当前 签入成功后提示未显示 直接进行了查询 可以暂缓100毫秒执行刷新 或者点击确认后再刷新
    backOut (item) {
      if (new Date(item.back_in_time).getTime() + 3 * 60000 < new Date().getTime()) {
        Toast.fail('超过3分钟')
        return false
      }
      const para = {
        use_id: item.id
      }
      Toast.loading({
        message: '请稍后...',
        forbidClick: true
      })
      api
        .axiosRequest(api.urlList.backSignOut, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            Toast.success('签出成功')
            Dialog.alert({
              title: '提示',
              message: '签出成功'
            }).then(() => {
              // on close
              this.recordListData = []
              this.queryList(1)
            })
          } else {
            Toast.fail('签出失败' + res.msg)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    backQR (item) {
      const para = {
        use_id: item.id
      }

      api
        .axiosRequest(api.urlList.backQR, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            Dialog.alert({
              title: '提示',
              message: '签入成功'
            }).then(() => {
              // on close
              this.recordListData = []
              this.queryList(1)
            })
          } else {

          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },

    onLoad () {
      // 监听到即执行
      console.log('滑到底了')
      //   再次调用 查询 下一页数据
      if (this.refreshing) {
        // 下拉刷新
        this.pageOption.page_no = 1
        this.queryList()
      } else {
        // 错误后点击刷新
        if (this.errorFlag) {
          // 说明上次加载失败 现在重新加载
          this.pageOption.page_no = 1
          this.errorFlag = false
          this.queryList()
          return false
        }
        // 触底加载
        if (this.recordListData.length >= this.pageOption.total) {
          this.finished = true
        } else {
          this.pageOption.page_no = this.pageOption.page_no + 1
          this.queryList()
        }
      }
    },
    onRefresh () {
      this.recordListData = []
      this.finished = false
      this.loading = true
      this.onLoad()
    },
    queryList (pageno) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      // let isRefresh = false
      if (pageno <= 1) {
        pageno = 1
        // isRefresh = true
      } else {
        pageno = this.pageOption.page_no
      }

      const para = {
        page_no: pageno,
        page_size: this.pageOption.page_size
      }
      api
        .axiosRequest(api.urlList.getPianoUserRecord, para)
        .then((res) => {
          // res.code = 20000
          if (res.code === common.resCode.OK) {
            if (res.list.length === 0) {
              // this.recordListData = []
              this.finished = true
              return false
            }
            res.list.forEach((item) => {
              const start = utils.formatDate(item.begin_time)
              const end = utils.formatDate(item.end_time)
              const inTime = utils.formatDate(item.in_time)
              const outTime = utils.formatDate(item.out_time)
              item.set_useTime = utils.formatTimeMDChinese(start) + ' ' + utils.formatTimeHourMinutes(start) + ' - ' + utils.formatTimeHourMinutes(end)
              item.set_sjUseTime = utils.formatTimeMDChinese(start) + ' ' +
                (!item.in_time ? '无签到' : utils.formatTimeHourMinutes(inTime)) + ' - ' +
                (!item.out_time ? '无签退' : utils.formatTimeHourMinutes(outTime))
            })

            this.pageOption.total = res.total
            this.recordListData.push(...res.list)
            this.loading = false
            this.refreshing = false
            Toast.clear()
            if (this.recordListData.length >= this.pageOption.total) {
              this.finished = true
            }
          } else {
            this.error = true
            this.errorFlag = true
            this.loading = false
            this.refreshing = false
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  width: 100%;
  height: 100%;
  .listBox {
    // background-color: #f7f8f9;
    // background-color: yellowgreen;
    padding-top: 1rem;

    height: 100%;

    .list-item {
      box-sizing: border-box;
      margin-bottom: 1rem;
      padding: 1rem;
      display: flex;
      flex-direction: column;
      background-color: #fafafa;
    }
    .at-name {
      font-size: 1.125rem;
      color: #333;
      font-weight: 550;
    }
    .predict-up-parent {
      margin-top: 0.625rem;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
    }
    .predict-up-text {
      font-size: 0.75rem;
      color: #333333;
    }

    .sj-up-parent {
      margin-top: 1rem;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
    }
    .sign-inout-btn {
      margin-left: auto;
      font-size: 0.75rem;
      line-height: 1rem;
      border-radius: 0.3125rem;
      padding: 0.125rem;
      background-color: #60b3ff;
      cursor: pointer;
      color: white;
    }
    .sj-up-text {
      font-size: 0.75rem;
      color: #666;
    }

    .list-bottom-status-hint {
      width: 100%;
      height: 3.125rem;
      text-align: center;
      line-height: 3.125rem;
      color: #666;
      font-size: 0.9375rem;
    }
  }
}
.van-list__finished-text {
  margin-top: 2rem;
}
</style>
